import React from 'react'
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import "./style.css"

/**
 * Adaptar esse componente
 * existe o handlfileUpload não precisa disso no novo form de cadastro.
 */
class Index extends React.Component {

    constructor(props) { 
        super(props)
        this.state = {
            image: null,
            file_image: null,
            exists_file: false,

        }
    }


    render() {
        const { is_avatar, handleFileImgDrop,  name_product, img, url_img, entity_id, before_file, file_dir_name } = this.props

        return (
            <Dropzone
            onDrop={(e) => {
                let reader = new FileReader();
                let file = e[0];

                reader.onloadend = () => {
                    this.setState({
                        file_image: file,
                        exists_file: true,
                        image: reader.result
                    })
                    handleFileImgDrop({
                        file_image: file,
                        exists_file: true,
                        image: reader.result
                    });
                }
                reader.readAsDataURL(file)
               

            }}>

                {({ getRootProps, getInputProps}) => (

                    <div {...getRootProps({ className: "dropzone avatar-circle" })} >
                        <input {...getInputProps()} />
                        {
                           img != null && img !== '' || this.state.image != null && this.state.image !== ''
                           ?
                           <img
                           className={ "thumbnail avatar-circle"}
                               src={this.state.image ? this.state.image : img} />
                           :
                           <></> 
                                
                        }

                    </div>

                )}

            </Dropzone>

        )
    }


}

Index.PropTypes = {
    t: PropTypes.any,
    history: PropTypes.any,
    loading: PropTypes.any,
    error: PropTypes.any,
    message: PropTypes.any,
    is_avatar: PropTypes.any,
    is_edit_img: PropTypes.any,
    handleFileImgDrop: PropTypes.func,
    handleFileImgDropUpdate: PropTypes.func,
    img: PropTypes.any,
    entity_id: PropTypes.any,
    before_file: PropTypes.any,
    file_dir_name: PropTypes.any,
    onDrop: PropTypes.func,

    url_img: PropTypes.any,
    name_product: PropTypes.any,

}
const mapStateToProps = state => {

    return {}
}
export default withTranslation()(withRouter(connect(mapStateToProps, {

})(
    (Index)
)))
